export class BwtTwoOwnCentralWarehousesDto {
    warehouseIntegraCode1 : string;
    warehouseName1: string;
    warehouseIntegraCode2: string;
    warehouseName2: string;
}